import { Col, Container, Row } from "react-bootstrap";

export default function LatestDataHeader() {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={4} className=" align-content-center">
                    Station
                </Col>
                <Col className=" align-content-center text-center">Ratings</Col>
                <Col className=" align-content-center text-center">Music Test</Col>
                <Col className=" align-content-center text-center">Listener Groups</Col>
            </Row>
        </Container>
    );
}
